import React from 'react'

import css from './Header.module.scss'

export const Header = () => (
    <header className={css.container}>
        <h1>Game of Life</h1>
    </header>
)
